const ANALYTICS_ACTIONS = {
  ADD_RECIPIENTS_ERROR: {
    category: 'Update Ticket',
  },
  ADD_RECIPIENTS_SUCCESS: {
    category: 'Update Ticket',
  },
  BULK_CLOSE_ERROR: {
    category: 'Update Ticket',
  },
  BULK_CLOSE_SUCCESS: {
    category: 'Update Ticket',
  },
  CLOSE_TICKET_ERROR: {
    category: 'Update Ticket',
  },
  CLOSE_TICKET_SUCCESS: {
    category: 'Update Ticket',
  },
  POST_COMMENT_SUCCESS: {
    category: 'Update Ticket',
  },
  POST_COMMENT_ERROR: {
    category: 'Update Ticket',
  },
  REMOVE_RECIPIENTS_ERROR: {
    category: 'Update Ticket',
  },
  REMOVE_RECIPIENTS_SUCCESS: {
    category: 'Update Ticket',
  },
  SHOW_ADD_USER_POPOVER: {
    category: 'Popovers_Recipient',
  },
  SHOW_ACCOUNTS_POPOVER: {
    category: 'Popovers_Account',
  },
  SUBMIT_TICKET_ERROR: {
    category: 'Create Ticket',
    label: 'New Ticket',
  },
  SUBMIT_TICKET_SUCCESS: {
    category: 'Create Ticket',
    label: 'New Ticket',
  },
};

const API_GROUPS = [
  {
    category: 'CT_API',
    url: '/api/ticketing',
  },
];

const DEV_KEY = 'UA-119854390-2';

const PRODUCTION_KEY = 'UA-119854390-1';

const TIMING_EVENT = 'TIMING_EVENT';

export { ANALYTICS_ACTIONS, API_GROUPS, DEV_KEY, PRODUCTION_KEY, TIMING_EVENT };
